// extracted by mini-css-extract-plugin
module.exports = {"callout":"Callout_callout__9rs_o","wrap":"Callout_wrap__NF_8m","title":"Callout_title__4l1oy","info":"Callout_info__KSTto","btns":"Callout_btns__uhUV9"};